import React from 'react';
import 'rc-dialog/assets/bootstrap.css';
import SelectCommon from '../Common/SelectCommonDefault';



class Facturacion extends React.Component {

    constructor( props ) {
        super( props );
        this.state = {
        };
        this.onLimiteChange = this.onLimiteChange.bind(this);
        this.onTopeChange = this.onTopeChange.bind(this);
    }

    onLimiteChange(value){
        let regularExpression = new RegExp("^[0-9]+$");
        if(regularExpression.test(value) || value == ""){
            this.setState({Limite: value},()=>this.props.onBlurTextBox("limiteFinanciacion",value))
        }
    }

    onTopeChange(value){
        let regularExpression = new RegExp("^[0-9]+$");
        if(regularExpression.test(value) || value == ""){
            this.setState({Tope: value},()=>this.props.onBlurTextBox("topePagoMinimo",value))
        }
    }

    componentWillReceiveProps(nextProps){
        const {tarjetas,data} = this.props;

        //SI SE TRATA DE UNA MODIFICACIÓN CARGO LOS DATOS CORRESPONDIENTES
        if (data && !this.props.tarjetas.vuelveDeAdicional && tarjetas.solicitudCuenta.GET_PRODUCTO_CABAL_PRODUCTO_ID && tarjetas.solicitudCuenta.GET_PRODUCTO_CABAL_PRODUCTO_ID.Id && tarjetas.esModificacion && !data.facturacionModificacion) {
            let limFin = tarjetas.datosSolicitud.LimiteFinanciacion;

            let tope = tarjetas.datosSolicitud.TopePagoMinimo;
                
            if(limFin){
                this.props.onBlurTextBox("limiteFinanciacion",limFin)
            }

            if(tope){
                this.props.onBlurTextBox("topePagoMinimo",tope)
            }
            
            //UNA VEZ CARGADOS LOS DATOS PASO A TRUE EL FLAG QUE LO INDICA
            if((limFin && data.limiteFinanciacion == limFin) && ((tope && data.topePagoMinimo == tope) || !tope )){
                this.props.cargarDatosModificacion("facturacionModificacion")
            } 
            
        }   
    }


    render() {
        const {producto, data, selectCombo, productoDefault, tarjetas} = this.props
        let parametroGeneral = data.GET_ATLAS_PARAMETRO_GENERAL;
        let topeMinimo = ""
        let topeMaximo = ""
        let limiteMin = ""
        let limiteMax = ""
        let valoresDefault = {}
        let errorLimite = false
        let errorTope = false

        if(producto){
            limiteMin = producto.LimiteFinanciacionDesde ? producto.LimiteFinanciacionDesde : ""
            limiteMax = producto.LimiteFinanciacionHasta ? producto.LimiteFinanciacionHasta : ""
            if(data.limiteFinanciacion  ){
                errorLimite = !(parseInt(data.limiteFinanciacion)>=parseInt(limiteMin) && parseInt(data.limiteFinanciacion)<=parseInt(limiteMax) )
            }

            if(producto.TopePagoMinimoXCuenta){
                topeMinimo= producto.TopePagoMinimoDesde ? producto.TopePagoMinimoDesde : ""
                topeMaximo= producto.TopePagoMinimoHasta ? producto.TopePagoMinimoHasta : ""
                if(data.topePagoMinimo){
                    errorTope = !(parseInt(data.topePagoMinimo)>=parseInt(topeMinimo) && parseInt(data.topePagoMinimo)<=parseInt(topeMaximo) )
                }
            }
        }
        if(productoDefault && tarjetas && !tarjetas.esModificacion){
            valoresDefault = productoDefault
            if(valoresDefault.LimiteFinanciacionDefaultInterfaz && (data.limiteFinanciacion == "0" || data.limiteFinanciacion == undefined) && valoresDefault.LimiteFinanciacionDefault) this.props.onBlurTextBox("limiteFinanciacion",valoresDefault.LimiteFinanciacionDefault)
            if(valoresDefault.TopePagoMinimoDefaultInterfaz && data.topePagoMinimo == "0" && valoresDefault.TopePagoMinimoDefault) this.props.onBlurTextBox("topePagoMinimo",valoresDefault.TopePagoMinimoDefault)
        }else if(tarjetas && tarjetas.esModificacion){
            valoresDefault = tarjetas.datosSolicitud;
            if(!valoresDefault.CarteraId) valoresDefault.CarteraId = productoDefault.CicloFacturacionDefaultId
        } 

        return (
            <div className="row">
                <div className="facturacion col-md-12">
                    <div className="divisor-section bottom-separator" >
                        <h2>Facturación </h2>
                    </div>
                        <div className="form-group bottom-separator-xs">
                            <label className="label-primary">
                                Límite de Financiación
                            </label>
                            <div >
                                <label className="label-secondary"> Límite de Financiación </label>
                                <input className="funcionamiento-limites-input" value={this.props.tarjetas.solicitudCuenta.limiteFinanciacion} onChange={(e)=>this.onLimiteChange(e.target.value)} className="input-facturacion" type="text"  />
                                <label className="label-secondary"> Entre ${limiteMin.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')} y ${limiteMax.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')}</label>
                            </div>
                            {data.ERROR_CUENTA["seleccionoLimiteFinanciacion"] == false && errorLimite  ? <label className="error">El límite de financiación debe estar entre los valores permitidos.</label> : null}
                            {data.ERROR_CUENTA["seleccionoLimiteFinanciacion"] == false && !errorLimite  ? <label className="error">Debe ingresar Límite de Financiación.</label> : null}
                        </div>
                        {producto && producto.TopePagoMinimoXCuenta && parametroGeneral.SINOTOPEPAGOMINIMO &&  <div className="form-group bottom-separator-xs">
                            <label className="label-primary">
                               Tope Pago Minimo
                                </label>
                            <div >
                                <label className="label-secondary"> Tope Pago Minimo </label>
                                <input className="funcionamiento-limites-input" value={this.props.tarjetas.solicitudCuenta.topePagoMinimo} onChange={(e)=>this.onTopeChange(e.target.value)} className="input-facturacion" type="text" maxLength="2" />
                                <label className="label-secondary">% (entre {topeMinimo}% y {topeMaximo}%)</label>
                            </div>
                            {data.ERROR_CUENTA["seleccionoTopePagoMinimo"] == false && errorTope ? <label className="error">El Tope debe estar entre los valores permitidos.</label> : null}
                            {data.ERROR_CUENTA["seleccionoTopePagoMinimo"] == false && !errorTope ? <label className="error">Debe ingresar Tope Pago Mínimo.</label> : null}
                        </div>}
                        <div className="form-group bottom-separator-xs">
                            <label className="label-primary">
                             Ciclos de Facturación
                            </label>
                            <SelectCommon infoData={data.GET_CARTERAS_PRODUCTO} valorCombo={valoresDefault["CicloFacturacionDefaultId"] ? valoresDefault["CicloFacturacionDefaultId"] : valoresDefault["CarteraId"]} selectCombo={selectCombo} nombreAction={"carteraId"} selecciones={data} />
                            {!data.ERROR_CUENTA["carteraId"] ? <label className="error">{"Debe seleccionar al menos una Cartera."}</label>: null}
                        </div>
                    
                </div>
            </div>

        )
    }
}

export default Facturacion;